import { render, staticRenderFns } from "./mo-import-client-test.vue?vue&type=template&id=23503c43&scoped=true&"
import script from "./mo-import-client-test.vue?vue&type=script&lang=js&"
export * from "./mo-import-client-test.vue?vue&type=script&lang=js&"
import style0 from "./mo-import-client-test.vue?vue&type=style&index=0&id=23503c43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23503c43",
  null
  
)

export default component.exports